import { render, staticRenderFns } from "./ReContactPatientData.vue?vue&type=template&id=01964dee&lang=pug&"
import script from "./ReContactPatientData.vue?vue&type=script&lang=js&"
export * from "./ReContactPatientData.vue?vue&type=script&lang=js&"
import style0 from "./ReContactPatientData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports